import { sharedEnvironment } from "../config/environmentService";

const DEFAULT_MEDIA_STREAMING_DISTRIBUTION_URL = sharedEnvironment.defaultMediaStreamingDistributionUrl;

export const getMediaStreamingUrlShared = (mediaStreamingUrlRoot: string, url?: string | null) =>
  url ? url.replace(DEFAULT_MEDIA_STREAMING_DISTRIBUTION_URL, mediaStreamingUrlRoot) : "";
